{
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "back": "Back",
    "close": "Close",
    "loading": "Loading…",
    "error_generic": "Something went wrong.",
    "error_network": "Network problem.",
    "not_found": "Page not found."
  },
  "lang": {
    "label": "Language"
  },
  "units": {
    "day_one": "{count} day",
    "day_other": "{count} days",
    "hour_one": "{count} hour",
    "hour_other": "{count} hours",
    "minute_one": "{count} minute",
    "minute_other": "{count} minutes",
    "second_one": "{count} second",
    "second_other": "{count} seconds",
    "d": "{count}d",
    "h": "{count}h",
    "m": "{count}m"
  },
  "og": {
    "join": "Join in taking photos at this event",
    "view": "See the photos from this event"
  },
  "events": {
    "wedding": "Wedding",
    "birthday": "Birthday",
    "baby_shower": "Baby Shower",
    "travel": "Travel",
    "corporate": "Corporate Event",
    "other": "Other Event"
  },
  "guest": {
    "opens_in": "Opens in {time}",
    "event_over": "Event ended",
    "camera_open": "Camera open",
    "load_failed": "Couldn't load the album. Try reloading the page.",
    "device_full": "This album has reached its guest limit. Please contact the organizer.",
    "your_photos": "Your photos",
    "no_photos": "No photos yet. Take your first one.",
    "photos_for_you_one": "{count} photo for you",
    "photos_for_you_other": "{count} photos for you",
    "opens_at": "Opens {date} · in {countdown}",
    "quota_used": "Photo quota used up. Contact the organizer to add more.",
    "unsent_one": "{count} photo not yet sent.",
    "unsent_other": "{count} photos not yet sent.",
    "unsent_closed_one": "{count} photo couldn't be sent, photo submission is closed.",
    "unsent_closed_other": "{count} photos couldn't be sent, photo submission is closed.",
    "resend_all": "Resend all",
    "processing": "Processing photo…",
    "capture_failed": "Photo failed to process.",
    "join_failed": "Couldn't join, try again.",
    "load_more": "Load more",
    "guest_fallback": "guest",
    "by_name": "by {name}",
    "status": {
      "queued": "waiting",
      "uploading": "sending",
      "failed": "failed, tap to resend",
      "quota": "quota used up, tap to resend once the organizer adds more",
      "hidden": "hidden by organizer",
      "sent": "sent"
    },
    "join": {
      "closed_hint": "Photo submission is closed. If you already joined, enter your name to see your photos.",
      "name_hint": "Enter your name so your photos can be recognized by the organizer.",
      "name_placeholder": "Your name",
      "submitting": "Joining…",
      "submit": "Join album →",
      "guests": "Guests",
      "host_message": "Message from the host",
      "your_name": "Your name",
      "start": "Start capturing"
    },
    "camera": {
      "unavailable": "Couldn't open the camera. You can still upload from your gallery via the photo button at the bottom right.",
      "tap_to_start": "Tap to turn on the camera.",
      "opening": "Opening…",
      "start": "Turn on camera",
      "switch": "Switch camera",
      "shoot": "Take photo",
      "upload": "Upload from gallery",
      "opens": "Opens {date}",
      "closed": "Closed",
      "time_left": "{time} left",
      "saved": "Saved",
      "flash_on": "Turn flash on",
      "flash_off": "Turn flash off",
      "zoom": "Zoom",
      "qr": "Show album QR",
      "qr_title": "Invite other guests",
      "left_one": "{count} photo left",
      "left_other": "{count} photos left",
      "shots": "Shots",
      "ideas": "Photo idea",
      "idea_1": "capture the toast",
      "idea_2": "the first dance",
      "idea_3": "someone mid-laugh",
      "idea_4": "your table, all in",
      "idea_5": "the cake before it's cut",
      "idea_6": "a selfie with the hosts"
    },
    "gallery": {
      "own_only": "This album's gallery only shows each guest their own photos.",
      "countdown_label": "Gallery opens in",
      "load_failed": "Couldn't load the gallery. Try reloading the page.",
      "empty": "No photos yet.",
      "login_hint": "Join the album to like / comment",
      "like": "Like",
      "unlike": "Unlike",
      "like_failed": "Couldn't like the photo."
    },
    "comments": {
      "loading": "Loading comments…",
      "load_failed": "Couldn't load comments.",
      "empty": "No comments yet.",
      "placeholder": "Write a comment…",
      "send": "Send",
      "delete": "Delete",
      "send_failed": "Couldn't send the comment."
    },
    "banner": {
      "in_app": "You're browsing inside a chat app. Open this link in Chrome or Safari so the camera works properly."
    },
    "upload": {
      "send_failed": "Failed to send photo.",
      "connection_lost": "Connection lost while uploading photo.",
      "interrupted": "Interrupted before finishing.",
      "put_failed": "Uploading {kind} failed ({status}).",
      "process_failed": "Failed to process photo."
    }
  },
  "errors": {
    "bad_key": "Key must start with albums/.",
    "bad_urls": "Upload URLs don't match, request new ones.",
    "photo_incomplete": "Photo data is incomplete.",
    "email_required": "Email is required.",
    "id_token_required": "id_token is required.",
    "quota_fields_required": "Enter a photo or guest count.",
    "quota_non_negative": "Quota must be a non-negative whole number.",
    "comment_length": "Comments must be 1 to {max} characters.",
    "invalid_device_id": "Invalid device ID.",
    "name_length": "Name must be 1 to 40 characters.",
    "invalid_after": "Invalid \"after\" parameter.",
    "oauth_failed": "Google verification failed, please try again.",
    "bad_signature": "Invalid webhook signature.",
    "account_not_found": "Account not found.",
    "not_joined": "You haven't joined this album yet.",
    "not_signed_in": "You're not signed in.",
    "unknown_device": "Unknown device.",
    "session_invalid": "Your session is invalid, please sign in again.",
    "token_invalid": "Your token is invalid, please join the album again.",
    "likes_off": "The host hasn't enabled likes.",
    "comments_off": "The host hasn't enabled comments.",
    "not_owner": "This album isn't yours.",
    "admin_only": "Admins only.",
    "po_not_allowed": "PO payment is for partners only, and only for album packages.",
    "visibility_own": "The host set the gallery to show each guest only their own photos.",
    "wrong_album": "This token belongs to another album.",
    "album_not_found": "Album not found.",
    "cover_not_found": "No cover.",
    "endpoint_not_found": "Endpoint not found.",
    "photo_not_found": "Photo not found.",
    "comment_not_found": "Comment not found.",
    "order_not_found": "Order not found.",
    "already_active": "The album is already active.",
    "device_full": "This album has reached its guest limit, please contact the organizer.",
    "inactive_pay": "The album isn't active yet, please complete the package payment first.",
    "inactive": "The album isn't active yet.",
    "outside_window": "Outside the photo upload window.",
    "upload_closed": "Photo submission is closed.",
    "upload_closed_topup": "Photo submission is closed, quota top-up no longer applies.",
    "quota_unavailable": "Photos can't be accepted right now.",
    "quota_full": "The album's photo quota is used up, please contact the organizer.",
    "device_quota": "You've reached your limit of {count} photos.",
    "settings_locked": "The album's look is locked and can't be changed anymore.",
    "photo_too_large": "Photo is too large, max 3 MB.",
    "cover_too_large": "Cover must be 2 MB or less.",
    "trial_used": "The free trial can only be used once per account.",
    "comment_rate": "Too many comments, please wait a moment.",
    "rate_limited": "Too many requests, please wait a moment.",
    "internal": "Something went wrong.",
    "missing_files": "Some files haven't finished uploading.",
    "gallery_mode_invalid": "Invalid gallery reveal time.",
    "gallery_delay_min": "Gallery delay must be at least 1 minute.",
    "title_length": "Title must be 1 to 80 characters.",
    "host_message_length": "Message for guests can be at most 280 characters.",
    "event_time_invalid": "Invalid event time.",
    "end_before_start": "End time must be after start time.",
    "film_filter_invalid": "Invalid film filter.",
    "filter_invalid": "Invalid filter.",
    "guests_invalid": "Invalid guest count.",
    "photos_per_guest_invalid": "Invalid photos per guest.",
    "end_extend_only": "The end time can only be extended.",
    "cover_jpeg": "Cover must be a JPEG.",
    "cover_empty": "Cover is empty.",
    "order_kind_invalid": "Invalid order type.",
    "payment_method_invalid": "Invalid payment method.",
    "settings_required": "Setting \"{field}\" is required.",
    "settings_invalid_value": "Invalid value for setting \"{field}\".",
    "settings_invalid": "Invalid album settings.",
    "settings_unknown": "Unknown setting \"{field}\".",
    "settings_bool": "Setting \"{field}\" must be true or false."
  },
  "landing": {
    "create_album": "Create album",
    "hero_1": "One QR,",
    "hero_2": "all your guests' moments.",
    "hero_desc": "Put one QR at your event. Guests snap photos from their own phones, and every shot lands straight in one shared gallery.",
    "testimonials_label": "What they say",
    "testimonials_sub": "Stories from hosts already using Qreate Moment.",
    "quote_1": "The best photos",
    "quote_em": "come from the people who",
    "quote_2": "truly enjoy their party",
    "testimonial_tag_wedding": "Wedding",
    "testimonial_tag_birthday": "Birthday",
    "testimonial_tag_corporate": "Corporate event",
    "testimonial_quote_1": "Guests just scanned the QR at their table, and by the next morning we already had hundreds of candid shots our photographer never caught.",
    "testimonial_quote_2": "All our friends joined in shooting from their own phones. No more chasing people for photos in the WhatsApp group.",
    "testimonial_quote_3": "A gathering of 200 people, one QR at every table. The gallery became internal content material that same week.",
    "how_it_works_label": "How it works",
    "how_heading_1": "Three steps,",
    "how_heading_em": "no hassle.",
    "step1_body": "Fill in the event name, pick a film style, and set the guest count. Done in two minutes.",
    "step2_title": "Share one QR",
    "step2_body": "Print the QR on tables or send the link. Guests start shooting right from their browser, no app needed.",
    "step3_title": "Every photo, together",
    "step3_body": "Every shot lands in one gallery, tagged with the guest's name. Download it all with one click.",
    "pricing_label": "Pricing",
    "pricing_heading_1": "Pay once,",
    "pricing_heading_em": "based on guest count.",
    "pricing_sub": "No subscription. You decide how many photos each guest can take.",
    "trial_label": "Free trial",
    "trial_detail": "Free · {guests} guests · {days} days",
    "tier_guests": "Up to {guests} guests",
    "tier_per_guest": "≈ {price} per guest",
    "faq_heading_1": "Questions?",
    "faq_heading_em": "We've got you.",
    "faq1_q": "Do guests need to download an app?",
    "faq1_a": "No. Guests just scan the QR or open the link, then start shooting right from their phone's browser.",
    "faq2_q": "Do guests need to create an account?",
    "faq2_a": "No. Guests only enter their name so every photo is tagged with who took it.",
    "faq3_q": "When can everyone see the photos?",
    "faq3_a": "You decide: right away, after the event ends, or a few hours later. Guests can always see their own photos.",
    "faq4_q": "How long are photos kept?",
    "faq4_a": "30 days after the event ends, with an option to extend. We send a reminder before the album is deleted.",
    "faq5_q": "How does payment work?",
    "faq5_a": "Through QRIS, a one-time payment per album. Price depends only on guest count.",
    "footer_tagline": "Every guest, one lens.",
    "footer_login": "Log in",
    "sticky_note": "Free for {guests} guests · no signup",
    "hero_title_1": "Every moment",
    "hero_title_is": "is",
    "hero_title_2": "One scan",
    "hero_title_away": "away",
    "cta_try": "Try for free",
    "ready_1": "Ready to",
    "ready_em": "Create Moment?",
    "more_q_1": "Got more",
    "more_q_em": "questions?",
    "contact_us": "Contact us"
  },
  "host": {
    "logout": "Log out",
    "untitled": "Untitled",
    "qr": {
      "preparing": "Preparing QR…",
      "alt": "Album QR code",
      "copy": "Copy link",
      "copied": "Copied!",
      "download": "Download QR"
    },
    "login": {
      "subtitle": "Log in to create and manage your event albums.",
      "opening_google": "Opening Google…",
      "google": "Log in with Google",
      "google_failed": "Google login failed, please try again.",
      "dev_mode": "Dev mode: log in without Google.",
      "dev_button": "Log in (dev)",
      "back_home": "← Back to home"
    },
    "wizard": {
      "duration": {
        "h1": "1 hour",
        "h2": "2 hours",
        "h4": "4 hours",
        "h12": "12 hours",
        "d1": "1 day",
        "d2": "2 days",
        "d3": "3 days"
      },
      "mode": {
        "immediate": "During the event",
        "after_event": "After the event",
        "delayed": "Extra delay"
      },
      "camera_required": "Camera not selected yet.",
      "titles": {
        "wedding_0": "Our Wedding",
        "wedding_1": "Our Happy Day",
        "wedding_2": "Forever Love",
        "wedding_3": "Our Vows",
        "birthday_0": "Birthday Party",
        "birthday_1": "Another Year, More Joy",
        "birthday_2": "Celebrate Together",
        "birthday_3": "My Special Day",
        "baby_shower_0": "Welcoming Our Little One",
        "baby_shower_1": "Our Baby Shower",
        "baby_shower_2": "Hello, World!",
        "baby_shower_3": "Our Little Bundle",
        "travel_0": "Trip Together",
        "travel_1": "Fun Getaway",
        "travel_2": "Travel Stories",
        "travel_3": "Our Adventure",
        "corporate_0": "Office Gathering",
        "corporate_1": "Appreciation Night",
        "corporate_2": "Annual Meeting",
        "corporate_3": "Company Anniversary",
        "other_0": "Moments Together",
        "other_1": "Good Times",
        "other_2": "A Special Night",
        "other_3": "Today's Story"
      },
      "head": {
        "event": {
          "title": "What are you celebrating?",
          "sub": "We'll set up the right look for your event."
        },
        "title": {
          "title": "Give your event a name",
          "sub": "This name shows up on the invite and the guest album."
        },
        "camera": {
          "title": "Pick a camera for your guests",
          "sub": "All guest photos are taken in this style."
        },
        "filter": {
          "title": "Pick a film",
          "sub": "The color character for every shot."
        },
        "format": {
          "title": "Instant photo size",
          "sub": "The shape of the printed photo frame."
        },
        "card": {
          "title": "Your invite card",
          "sub": "This is what guests see when they open the link."
        },
        "reveal": {
          "title": "When do photos show up?",
          "sub": "Save the surprise, or share it live all through the event."
        },
        "visibility": {
          "title": "Who can see the photos?",
          "sub": "Set the privacy for the guest album."
        },
        "interaction": {
          "title": "Let guests join in",
          "sub": "Turn on the ones you like."
        },
        "date": {
          "title": "When's your event?",
          "sub": "The guest camera stays open for the whole event."
        },
        "guests": {
          "title": "How many guests?",
          "sub": "Price depends on your guest count."
        }
      },
      "editable_later": "You can change this later",
      "trial_badge": "Free trial · {guests} guests × {photos} photos · {days} days",
      "starting_from": "From {price}",
      "create_failed": "Couldn't create the album.",
      "saving": "Saving…",
      "create": "Create album",
      "next": "Next →",
      "cover_upload_failed_alert": "Cover upload failed. Upload it again from the album page after payment.",
      "title": {
        "placeholder": "Andi & Bela's Wedding",
        "suggestions_label": "SUGGESTIONS"
      },
      "camera": {
        "analogue_label": "Analogue",
        "analogue_hint": "Full-frame photos with real film character",
        "instant_label": "Instant",
        "instant_hint": "White polaroid-style frame"
      },
      "format": {
        "hint_mini": "2:3 portrait"
      },
      "card": {
        "change_cover": "Change cover",
        "upload_cover": "Upload cover",
        "remove": "Remove",
        "no_cover_hint": "No cover yet — we'll use the default {type} photo.",
        "message_label": "Message for guests (optional)",
        "message_placeholder": "Thanks for coming! Snap the moments you love.",
        "title_placeholder": "Your event name",
        "name_placeholder": "Enter your name",
        "enter_album": "Enter album →"
      },
      "reveal": {
        "immediate_hint": "Photos appear in the album the moment they're taken.",
        "after_event_hint": "The album opens once the event ends.",
        "delayed_label": "Extra delay",
        "delayed_hint": "Surprise: the album opens a while after the event.",
        "delay_label": "Delay after the event ends",
        "custom_minutes_label": "Or set your own (minutes)"
      },
      "visibility": {
        "all_label": "Everyone",
        "all_hint": "Every guest can see photos from all guests.",
        "own_label": "Own photos only",
        "own_hint": "Guests only see photos they took. You still see everything."
      },
      "interaction": {
        "sample_comments": "✎ 3 wishes",
        "no_extras": "No likes or comments",
        "likes_label": "Photo likes",
        "likes_hint": "Guests can give a ♥",
        "comments_label": "Comments",
        "comments_hint": "Guests can leave a wish on a photo"
      },
      "date": {
        "date_label": "Date",
        "time_label": "Start time",
        "duration_label": "HOW LONG"
      },
      "guests": {
        "up_to_label": "Up to",
        "count_one": "{count} guest",
        "count_other": "{count} guests",
        "upgrade_hint": "You can upgrade anytime",
        "slider_aria": "Number of guests",
        "photos_per_guest_label": "PHOTOS PER GUEST"
      }
    },
    "list": {
      "title": "My albums",
      "try_free": "Try for free",
      "loading": "Loading albums…",
      "load_failed": "Couldn't load albums. Try reloading the page.",
      "empty": "No albums yet. Start with the free trial ({guests} guests, {days} days) or create one now.",
      "status": {
        "active": "Active",
        "pending_payment": "Awaiting payment",
        "draft": "Draft",
        "expired": "Expired",
        "done": "Done"
      },
      "photos_count_one": "{count}/{total} photo",
      "photos_count_other": "{count}/{total} photos"
    },
    "album": {
      "pending_desc": "The album can't receive photos until payment is complete.",
      "pay_now": "Pay now",
      "upload_closed": "Photo submission is closed.",
      "topup": "Top up quota",
      "extend": "Extend",
      "guests_heading": "People ({count})",
      "no_guests": "No guests have joined yet.",
      "guest_untitled": "Unnamed",
      "guest_photo_count_one": "{count} photo",
      "guest_photo_count_other": "{count} photos",
      "photo_alt": "Photo from {name}",
      "uploading": "Uploading…",
      "show": "Show",
      "hide": "Hide",
      "comments_open": "Comments",
      "no_photos": "No photos yet.",
      "load_more": "Load more",
      "not_found": "Album not found.",
      "comment_delete_failed": "Couldn't delete the comment.",
      "comments_load_failed": "Couldn't load comments.",
      "cover_title": "Invite cover",
      "cover_alt": "Album cover",
      "cover_default_alt": "Default cover",
      "cover_default_badge": "Default",
      "cover_change": "Change",
      "cover_upload": "Upload",
      "cover_remove": "Remove",
      "cover_hint": "Shows on the guest page and when the link is shared.",
      "message_title": "Message for guests",
      "message_hint": "Shown to guests when they join. Optional, max 280 characters.",
      "message_save": "Save message",
      "message_saved": "Saved",
      "message_failed": "Couldn't save the message.",
      "cover_failed_query": "Cover upload failed — upload it again below.",
      "cover_upload_failed": "Cover upload failed.",
      "cover_delete_failed": "Couldn't delete the cover.",
      "settings": {
        "camera_analogue": "Analogue Film",
        "camera_instant": "Instant Film"
      },
      "download_zip": "Download all (zip)",
      "download_preparing": "Preparing zip… {done} of {total}",
      "download_failed": "Failed, try again"
    },
    "pay": {
      "kind": {
        "package": "Album package",
        "topup_photo": "Top up 100 photos",
        "topup_device": "Top up 50 guests",
        "extend_retention": "Extend 30 days"
      },
      "paid_title": "Payment received 🎉",
      "paid_desc": "Album updated, taking you back to the album page…",
      "back": "← Back to album",
      "title": "Payment",
      "package_summary": "Package {guests} guests × {photos} photos",
      "total": "Total {amount}",
      "choose_purchase": "Choose a purchase",
      "method": "Payment method",
      "method_po": "Pay via PO (partners)",
      "create_pending": "Creating invoice…",
      "create": "Create invoice",
      "po_pending_title": "Awaiting admin verification",
      "po_pending_desc": "Invoice of {amount} recorded. The album activates once admin verifies the PO.",
      "qris_hint": "Scan with your payment app, this page updates itself.",
      "dev_simulate": "Simulate payment (dev)"
    }
  },
  "admin": {
    "title": "Admin panel",
    "forbidden": "Admins only.",
    "po_pending_heading": "POs awaiting verification",
    "po_empty": "No POs waiting.",
    "activate": "Activate",
    "emergency_heading": "Add emergency quota",
    "id_placeholder": "Album ID",
    "photos_placeholder": "Photos",
    "guests_placeholder": "Guests",
    "add": "Add",
    "quota_result": "Quota is now {photos} photos / {guests} guests."
  },
  "event": {
    "camera": "Open camera",
    "add_photo": "Add photos",
    "join_title": "What's your name?",
    "stat": {
      "moments": "Moments",
      "left": "Left",
      "opens_in": "Opens in",
      "ended": "Ended",
      "people": "People"
    },
    "upgrade": {
      "label": "Upgrade this event?",
      "title": "Add guests",
      "trial_sub": "Free plan is limited to {count} guests",
      "sub": "{used} of {quota} guests joined"
    },
    "settings": {
      "title": "Event settings",
      "name": "Event name",
      "start": "Starts",
      "end": "Ends",
      "reveal": "Reveal time",
      "per_guest": "Photos per person",
      "camera_filter": "Camera & filter",
      "camera_frame": "Camera & frame",
      "visibility": "Who can see",
      "expires": "Active until"
    },
    "tab_label": "Photos",
    "tab_all": "All photos",
    "tab_mine": "My photos",
    "meta_photos_one": "{count} photo",
    "meta_photos_other": "{count} photos",
    "meta_guests_one": "{count} guest",
    "meta_guests_other": "{count} guests"
  }
}
